import React from "react";
import { DescriptionFieldProps } from "@rjsf/utils";
import { Description } from "./__styles__/DescriptionFieldTemplate";

export const DescriptionFieldTemplate = (props: DescriptionFieldProps) => {
  const { description, id } = props;
  return <Description id={id}>{description}</Description>;
};
